export function orgsQuery(): string {
  return `
        query {
          orgs {
            id
            name
            timezone
            accountingInventoryGroupId
            accountingInventoryGroupIds
            accountingSetup {
              initialSyncMethod
              isFinished
              isReconciled
              balanceExportStartDate
              balanceExportReportId
            }
            subscriptionDetails {
              accountingSeats
              walletSeats
            }
            provisionedAccountingUsers
            provisionedWalletUsers
            userRoles {
              userId
              role
            }
            taxConfig {
              capitalizeTradingFees
              wrappingTreatments
            }
            baseCurrency
            invoicingSettings {
              fromEmail
              fromName
              bitcoinAddress
              bitcoinXPub
              bitcoinXPubPath
              ethAddress
              zecAddress
              usdcAddress
              usdtAddress
              avaxAddress
              alotAddress
              aleoAddress
            }
            accountingConfig {
              networkContactIds {
                contactId
                blockchain
              }
              defaultFeeCategoryId
              allowTxnInference
              collapseAcrossWallets
              defaultAccountsReceivableCategoryId
              defaultForexCategoryId
              defaultAccountsPayableCategoryId
              defaultFeeCategoryIds {
                categoryId
                blockchain
              }
              useTxnMemoForReconciliation
            }
            trialExpiry
            flags {
              key
              value
            }
            displayConfig {
              useOrgTimezone
            }
            hardCloseDate
            scimEnabled
            isDisabled
          }
        }
      `;
}
